export const servicesData = [
  {
    id: 1,
    title: "OPD Consultation",
    description: "Expert veterinary consultation for your pets",
    icon: "stethoscope"
  },
  {
    id: 2,
    title: "Vaccination Programs",
    description: "Complete vaccination schedule for dogs and cats",
    icon: "syringe"
  },
  {
    id: 3,
    title: "Deworming & Parasite Control",
    description: "Regular deworming and parasite prevention",
    icon: "shield"
  },
  {
    id: 4,
    title: "Basic Diagnostics",
    description: "On-site diagnostic services",
    icon: "activity"
  },
  {
    id: 5,
    title: "Pet Health Certificates",
    description: "Official health certificates for travel",
    icon: "file-text"
  },
  {
    id: 6,
    title: "Nutrition & Diet Advice",
    description: "Professional pet nutrition guidance",
    icon: "apple"
  }
];

export const groomingServices = [
  {
    id: 1,
    title: "Bath & Blow Dry",
    description: "Complete bathing with professional blow dry",
    icon: "droplet"
  },
  {
    id: 2,
    title: "Haircut & Styling",
    description: "Professional grooming and styling",
    icon: "scissors"
  },
  {
    id: 3,
    title: "Nail Trimming",
    description: "Safe and gentle nail care",
    icon: "sparkles"
  },
  {
    id: 4,
    title: "Ear & Eye Cleaning",
    description: "Thorough ear and eye hygiene",
    icon: "eye"
  },
  {
    id: 5,
    title: "De-shedding",
    description: "Professional de-shedding treatment",
    icon: "wind"
  },
  {
    id: 6,
    title: "Tick & Flea Bath",
    description: "Specialized tick and flea treatment",
    icon: "bug"
  }
];

export const shopCategories = [
  {
    id: 1,
    title: "Premium Dog & Cat Food",
    description: "Nutritious food for all breeds",
    icon: "package"
  },
  {
    id: 2,
    title: "Treats & Supplements",
    description: "Healthy treats and vitamins",
    icon: "candy"
  },
  {
    id: 3,
    title: "Leashes, Collars & Harnesses",
    description: "Quality walking accessories",
    icon: "link"
  },
  {
    id: 4,
    title: "Bowls, Toys & Beds",
    description: "Comfort and play essentials",
    icon: "home"
  },
  {
    id: 5,
    title: "Grooming Accessories",
    description: "Home grooming tools",
    icon: "scissors"
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "One-stop pet care clinic",
    description: "All services under one roof",
    icon: "building"
  },
  {
    id: 2,
    title: "European Imported Vaccines",
    description: "We use premium quality vaccines imported from Europe",
    icon: "shield"
  },
  {
    id: 3,
    title: "Clean & modern setup",
    description: "Hygienic and comfortable environment",
    icon: "sparkles"
  },
  {
    id: 4,
    title: "Honest advice, no over-treatment",
    description: "Ethical and transparent care",
    icon: "heart"
  },
  {
    id: 5,
    title: "Pet-friendly handling",
    description: "Stress-free experience for your pets",
    icon: "smile"
  },
  {
    id: 6,
    title: "Trusted by local pet parents",
    description: "Years of experience and care",
    icon: "award"
  }
];

export const contactInfo = {
  phones: ["+91 98797 71213", "+91 99049 23988", "+91 79841 12327"],
  phoneLinks: ["9879771213", "9904923988", "7984112327"],
  address: "Suvidha Park, 5, VIP Road, Near HDFC Bank, Amit Nagar Circle, Karelibaug, Vadodara, Gujarat 390022",
  timings: "8:00 AM - 8:00 PM"
};